import { render, staticRenderFns } from "./zjcx.vue?vue&type=template&id=9a3cc4e0&scoped=true&"
import script from "./zjcx.vue?vue&type=script&lang=js&"
export * from "./zjcx.vue?vue&type=script&lang=js&"
import style0 from "./zjcx.vue?vue&type=style&index=0&id=9a3cc4e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a3cc4e0",
  null
  
)

export default component.exports